<template>
  <page :title="title">
    <v-container fluid grid-list-sm>
      <v-card>
        <message :messages="messages"></message>
        <v-card-text>
          <v-layout row wrap align-center>
            <v-flex xs12 sm4>
              <cal-picker
                v-model="form.tranDateFrom"
                :label="labels.tranDateFrom"
                :data-vv-as="labels.tranDateFrom"
                data-vv-name="form.tranDateFrom"
                :error-messages="errors.collect('form.tranDateFrom')"
                v-validate="'required'"
              />
            </v-flex>
            <v-flex xs12 sm4>
              <cal-picker
                v-model="form.tranDateTo"
                :label="labels.tranDateTo"
                :data-vv-as="labels.tranDateTo"
                data-vv-name="form.tranDateTo"
                :error-messages="errors.collect('form.tranDateTo')"
                v-validate="'required'"
              />
            </v-flex>
            <v-flex xs12 class="ma-0 pa-0" />
            <v-flex xs12 sm4>
              <cal-picker
                v-model="form.glTranDate"
                :label="labels.glTranDate"
                :data-vv-as="labels.glTranDate"
                data-vv-name="form.glTranDate"
                :error-messages="errors.collect('form.glTranDate')"
                v-validate="'required'"
              />
            </v-flex>
            <v-flex xs12 class="ma-0 pa-0" />
            <v-flex xs12>
              <v-text-field
                v-model="form.branch"
                :label="labels.branch"
                :error-messages="errors.collect('form.branch')"
                data-vv-name="form.branch"
                :data-vv-as="labels.branch"
                append-icon="mdi-magnify"
                readonly
                @click="showBranchHelpList = true"
                clearable
                v-validate="'required'"
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-model="form.polType"
                :label="labels.polType"
                :error-messages="errors.collect('form.polType')"
                data-vv-name="form.polType"
                :data-vv-as="labels.polType"
                append-icon="mdi-magnify"
                readonly
                @click="showPolTypeHelpList = true"
                clearable
                v-validate="'required'"
              />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn color="secondary" @click="doPrint">
            {{ labels.print }}
            <v-icon right>mdi-clipboard-check-outline</v-icon>
          </v-btn>
          <v-btn color="primary" @click="doPost">
            {{ labels.post }}
            <v-icon right>mdi-clipboard-check</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
    <v-dialog v-model="showBranchHelpList" width="900px" persistent>
      <multi-branch-help-list :brn="form.branch" @close="showBranchHelpList = false" @doAssign="doAssignBranch($event)"></multi-branch-help-list>
    </v-dialog>
    <v-dialog v-model="showPolTypeHelpList" width="900px" persistent>
      <multi-pol-type-help-list
        :pt="form.polType"
        @close="showPolTypeHelpList = false"
        @doAssign="doAssignPolType($event)"
      ></multi-pol-type-help-list>
    </v-dialog>
  </page>
</template>

<script>
import MultiBranchHelpList from '@/components/core/common/dialog/MultiBranchHelpList.vue'
import MultiPolTypeHelpList from '@/components/core/common/dialog/MultiPolTypeHelpList'
import MessageMixin from '@/mixins/message'
export default {
  data() {
    return {
      title: 'Post Outstanding Claims Reserves',
      showBranchHelpList: false,
      showPolTypeHelpList: false,
      form: {
        action: undefined,
        tranDateFrom: new Date(),
        tranDateTo: new Date(),
        glTranDate: new Date(),
        branch: 'All',
        polType: 'All'
      },
      labels: {
        tranDateFrom: 'Claim Transaction Date From',
        tranDateTo: 'To',
        glTranDate: 'GL Transaction Date',
        branch: 'Branch',
        polType: 'Policy Type',
        print: 'Print Checklist',
        post: 'Post to Accounts'
      }
    }
  },
  components: {
    MultiBranchHelpList,
    MultiPolTypeHelpList
  },
  mixins: [MessageMixin],
  computed: {
    osClmRes() {
      return this.$store.state.osClmRes
    },
    menu() {
      return this.osClmRes.menu
    }
  },
  methods: {
    async doAssignBranch(Obj) {
      this.form.branch = ''
      this.form.branch = Obj.finalSelectedItems.toString()
      this.$validator.validate('form.branch')
    },
    async doAssignPolType(Obj) {
      this.form.polType = []
      this.form.polType = Obj.finalSelectedItems.toString()
      this.$validator.validate('form.polType')
    },
    doPrint() {
      this.form.action = 'print'
      this.validateForm()
    },
    doPost() {
      this.form.action = 'post'
      this.validateForm()
    },
    async validateForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.sendRequest()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async sendRequest() {
      const apiURI = this.menu.processOSClmRes
      if (apiURI) {
        try {
          this.submitting = true
          const result = await this.$http.post(apiURI, this.form)
          if (result.data) {
            this.$toast.success('Job successfully submitted to batch job process.')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  }
}
</script>
